import { render } from "./EmailPreviewPanel.vue?vue&type=template&id=81cd64a4&scoped=true"
import script from "./EmailPreviewPanel.vue?vue&type=script&lang=js"
export * from "./EmailPreviewPanel.vue?vue&type=script&lang=js"

import "./EmailPreviewPanel.vue?vue&type=style&index=0&id=81cd64a4&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81cd64a4"]])

export default __exports__